import { render, staticRenderFns } from "./BuildingEditConfigurationsTab.vue?vue&type=template&id=56e89a2a"
import script from "./BuildingEditConfigurationsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditConfigurationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports